import { Order } from "@common/order";

export interface OrdersState {
  orders: Order[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  isLoading: boolean;
  error: any;
}

export const initialState: OrdersState = {
  orders: [],
  totalElements: 0,
  totalPages: 0,
  currentPage: 0,
  isLoading: false,
  error: null
};
